import angular from 'angular';
import tunnelComponent from './tunnel.component';
import TunnelService from './tunnel.service';
import tunnelConfig from './tunnel.config';
import ModalAddressController from './modal-address/modal-address.controller';
import ModalDriversRegisterController from './modal-drivers-register/modal-drivers-register.controller';
import AddressService from '../address/address.service';

let tunnelModule = angular.module('app.tunnel', [])
    .controller('ModalAddressController', ModalAddressController)
    .controller('ModalDriversRegisterController', ModalDriversRegisterController)
    .component('tunnel', tunnelComponent)
    .service('TunnelService', TunnelService)
    .service('AddressService', AddressService)
    .config(tunnelConfig);

export default tunnelModule;



/** WEBPACK FOOTER **
 ** ./www/components/tunnel/tunnel.js
 **/